import {Type} from './Type';
export default class Immutable {
	public static copy<T extends Object>(arg: T):T {
		if(Type.isArray(arg)) {
			const a = [];
			for(const i of arg) {
				if(Type.isObject(i)) {
					a.push(Immutable.copy(i));
				} else {
					a.push(i);
				}
			}
			return a as any;
		} else {
			const a:any = {...arg as Object};
			for(const i in a) {
				if(Type.isObject(a[i])) {
					a[i] = Immutable.copy((a[i]));
				}
			}
			return a;
		}
	}
}
